import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const RECIBOS_API = 'recibos';
export const recibosApi = `${baseUrl}/${RECIBOS_API}`;

export const allRecibosService = async (params) => {
  const res = await axios.get(recibosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveRecibosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${recibosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(recibosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneRecibosService = async (id) => {
  const res = await axios.get(`${recibosApi}/${id}`, { headers: token({}) });
  return res;
};

export const deleteRecibosService = async (id) => {
  const res = await axios.delete(`${recibosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const updateEstatusRecibosService = async (id, data) => {
  const res = await axios.patch(`${recibosApi}/${id}/update_estatus`, data, {
    headers: token({}),
  });
  return res;
};

export const estadisticasRecibosService = async (params) => {
  const res = await axios.get(`${recibosApi}/estadisticas`, {
    headers: token({}),
    params,
  });
  return res;
};
